import { Box, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

export const AgendaOpenedIndicator = () => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t("audiences.agendaOpened")}>
      <Box
        component="span"
        role="img"
        aria-label={t("audiences.agendaOpened")}
        tabIndex={0}
        sx={{
          position: "absolute",
          right: -2,
          bottom: -2,
          width: 12,
          height: 12,
          borderRadius: "50%",
          bgcolor: "success.main",
          border: "2px solid",
          borderColor: "background.paper",
          boxSizing: "border-box",
        }}
      />
    </Tooltip>
  );
};
